import { createContext } from 'react';
export const GlobalContext = /*#__PURE__*/createContext({});
export const PlatformCode = "cloud_cut_locallife";